export const selectUser = (state) => state.user;

export const selectUserToken = (state) => selectUser(state).token;
export const selectUserRole = (state) => selectUser(state).role;
